import { getDetailsTabRouteObjects } from '../../../utility/route';
import Task from '../task.vue';

import TasksList  from '../components/task/task-list.vue';

import { tasksListLDTRoutes} from './routes';

export default [{
    path: "/main/task",
    name: "task",
    component: Task,
    redirect: "main/task/tasks",
    children: [
        ...getDetailsTabRouteObjects(tasksListLDTRoutes, TasksList),
        //...getDetailsTabRouteObjects(licencesListLDTRoutes, LicenceList),


        // {
        //     name: 'catalog_statement',
        //     path: 'statements',
        //     redirect: 'statements/overview',
        //     component: Statement,
        //     children: [
        //       {
        //         name: 'statement_overview',
        //         path: 'overview',
        //         component: StatementOverview
        //       },
        //       {
        //         name: 'statement_payment',
        //         path: 'payments',
        //         component: Payments
        //       }
        //     ]
        //   },


    ],
},


];